import { Ellipsis } from 'lucide-react';
import { useId, useState } from 'react';
import { Popover } from './ui/popover.tsx';
import type { RecordMenuItem } from './record-head-values.ts';
import { Icon } from './ui/icon.tsx';

export { figureGridClass, initialsOf, type RecordFigure, type RecordMenuItem } from './record-head-values.ts';

// Der Datensatz-Kopf selbst ist `RecordHeader` (`components/ui/record-header.tsx`, Ticket 1.310: ein Kopf für alle
// Datensätze); hier bleiben das Menü „…“ und die Werte-Re-Exporte.

/** Symbolknopf „…“ mit Menü (am Handy als Blatt von unten). Gesperrte Einträge zeigen den Grund darunter. */
export function RecordMenu({ label, items }: { label: string; items: readonly RecordMenuItem[] }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      label={label}
      align="end"
      className="w-popover-w !p-space-2"
      trigger={(props) => (
        <button
          type="button"
          aria-label={label}
          aria-haspopup="dialog"
          {...props}
          className="grid size-10 cursor-pointer place-items-center rounded-full border border-ring-line bg-card text-ink-2 hover:bg-tile pointer-coarse:size-11"
        >
          <Icon icon={Ellipsis} size="md" aria-hidden />
        </button>
      )}
    >
      <ul className="flex flex-col gap-space-1">
        {items.map((item, i) => (
          <li key={item.label}>
            <button
              type="button"
              disabled={item.disabled}
              aria-describedby={item.disabled && item.reason ? `${id}-${i}` : undefined}
              onClick={() => {
                setOpen(false);
                item.onSelect();
              }}
              className="flex min-h-10 w-full cursor-pointer items-center rounded-tile px-space-3 text-left text-row text-ink hover:bg-tile disabled:cursor-default disabled:text-ink-3 disabled:hover:bg-transparent pointer-coarse:min-h-11"
            >
              {item.label}
            </button>
            {item.disabled && item.reason ? (
              <p id={`${id}-${i}`} className="type-meta px-space-3 pb-space-1 text-ink-3">
                {item.reason}
              </p>
            ) : null}
          </li>
        ))}
      </ul>
    </Popover>
  );
}
